import { takeEvery, put, select } from 'redux-saga/effects';
import {
  types as hashtagTypes,
} from 'wpt-duck-hashtags';

import * as envActions from './actions';
import * as envSelectors from './selectors';

let sagaExecuted = false;

function* setEnvAndProxy() {
  // only do this once
  if (!sagaExecuted) {
    sagaExecuted = true;
    const hashtags = yield select(state => state.hashtags);
    const currentWs = yield select(envSelectors.getWs);
    const windowWptProxyValue = window.WPT_proxyvalue;

    const { ws } = hashtags;
    let { proxy } = hashtags;
    const { hostname } = window.location;

    if (currentWs !== ws || currentWs === undefined) {
      if (windowWptProxyValue) proxy = windowWptProxyValue;

      yield put(envActions.set(ws, proxy, hostname));
    }
  }
}

function* favoritesSaga() {
  yield takeEvery(hashtagTypes.UPDATE, setEnvAndProxy);
}

export default favoritesSaga;
